import React, { createContext, useEffect, useState } from 'react'
import myjson from 'lang.json'

export const languageContext = createContext()
export default function LanguageContextProvider(props) {
    let [jsonfile, setJsonFile] = useState(myjson)
    let [weblanguage, setlanguage] = useState(localStorage.getItem('weblanguage') || "ar")

    useEffect(() => {
        setJsonFile(myjson)
    }, [])

    useEffect(() => {
        localStorage.setItem('weblanguage', weblanguage);
    }, [weblanguage])

    let changelanguageTo = (language) => {
        language == 'en' ? setlanguage('en') : setlanguage('ar');
    }

    return (
        <languageContext.Provider value={{ weblanguage, changelanguageTo, jsonfile }}>
            {props.children}
        </languageContext.Provider>
    )
}
